module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step3_Image15.edcc2f74.jpg";